
<div class="w-100 d-flex justify-content-end align-items-center px-2 py-1">
	<small
		class="text-muted"
		[tooltip]="buildTooltip"
		placement="top"
		[container]="'body'"
		[delay]="300">
		{{ buildLabel }}
	</small>
</div>